module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Case: " + _vm._s(_vm.legal_case.number))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.statusDisplay)), _c('br')])]), _vm._v(" "), _c('Assignment', {
    key: _vm.assignmentKey,
    attrs: {
      "user_is_assignee": _vm.legal_case.user_is_assignee,
      "allowed_group_ids": _vm.legal_case.allowed_groups,
      "user_in_group": _vm.legal_case.user_in_group,
      "assigned_to_id": _vm.legal_case.assigned_to_id,
      "assign_url": _vm.assign_url
    },
    on: {
      "update-assigned-to-id": _vm.updateAssignedToId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Action\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.openStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.openInspection()
      }
    }
  }, [_vm._v("\n                                Inspection\n                              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.openStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.openOffence()
      }
    }
  }, [_vm._v("\n                              Offence\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.openStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "disabled": !_vm.sanctionOutcomeVisibility,
      "type": "button",
      "value": "Sanction Outcome"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSanctionOutcome()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.openStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('brief_of_evidence')
      }
    }
  }, [_vm._v("\n                              Brief of Evidence\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.briefOfEvidenceStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('back_to_case')
      }
    }
  }, [_vm._v("\n                              Back To Case\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.briefOfEvidenceVisibility) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.printDocument('brief_of_evidence')
      }
    }
  }, [_vm._v("\n                              Print Brief of Evidence\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.briefOfEvidenceStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('send_to_manager')
      }
    }
  }, [_vm._v("\n                              Send To Manager\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.backToOfficerVisibility) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('back_to_officer')
      }
    }
  }, [_vm._v("\n                              Back To Officer\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withManagerStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('approve_brief_of_evidence')
      }
    }
  }, [_vm._v("\n                              Approve\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionCoordinatorStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('prosecution_brief')
      }
    }
  }, [_vm._v("\n                              Prosecution Brief\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionCoordinatorProsecutionBriefStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('send_to_prosecution_council')
      }
    }
  }, [_vm._v("\n                              Send To Prosecution Council\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.prosecutionBriefVisibility) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.printDocument('prosecution_brief')
      }
    }
  }, [_vm._v("\n                              Print Prosecution Brief\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionCouncilStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('back_to_prosecution_coordinator')
      }
    }
  }, [_vm._v("\n                              Back to Prosecution Coordinator\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionCouncilStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('endorse_prosecution_brief')
      }
    }
  }, [_vm._v("\n                              Endorse Prosecution Brief\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionManagerStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('approve_for_court')
      }
    }
  }, [_vm._v("\n                              Approve for Court\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionManagerStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('back_to_prosecution_council')
      }
    }
  }, [_vm._v("\n                              Back to Prosecution Council\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "close-button"
    }
  }, [(_vm.canUserAction && !_vm.closedStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('close')
      }
    }
  }, [_vm._v("\n                              Close\n                            ")])]) : _vm._e()])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.runTab
    }
  }, [_vm._v("Running Sheet")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.cTab
    }
  }, [_vm._v("Case Details")])]), _vm._v(" "), (_vm.briefOfEvidenceVisibility) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.bTab
    }
  }, [_vm._v("Brief of Evidence")])]) : _vm._e(), _vm._v(" "), (_vm.prosecutionBriefVisibility) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.pTab
    }
  }, [_vm._v("Prosecution Brief")])]) : _vm._e(), _vm._v(" "), (_vm.courtProceedingsVisibility) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.cpTab
    }
  }, [_vm._v("Court Proceedings")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.rTab
    }
  }, [_vm._v("Related Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.runTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Running Sheet",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "row action-button"
  }, [(!_vm.readonlyRunningSheet) ? _c('div', [_c('a', {
    staticClass: "btn btn-primary pull-right new-row-button",
    on: {
      "click": function($event) {
        return _vm.createNewRunningSheetEntry()
      }
    }
  }, [_vm._v("\n                                            New Row\n                                          ")])]) : _c('div', [_c('a', {
    staticClass: "btn btn-primary pull-right new-row-button",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                                            New Row\n                                          ")])])]), _vm._v(" "), _c('datatable', {
    ref: "running_sheet_table",
    attrs: {
      "id": "running-sheet-table",
      "dtOptions": _vm.dtOptionsRunningSheet,
      "dtHeaders": _vm.dtHeadersRunningSheet,
      "parentStyle": " "
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.cTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Case Details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Title\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case.title),
      expression: "legal_case.title"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "type": "text"
    },
    domProps: {
      "value": (_vm.legal_case.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.legal_case, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case.details),
      expression: "legal_case.details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.legal_case.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.legal_case, "details", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.legal_case.defaultDocumentUrl) ? _c('div', [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Documents\n                                        "), _c('filefield', {
    ref: "legal_case_documents",
    attrs: {
      "name": "legal-case-documents",
      "isRepeatable": true,
      "documentActionUrl": _vm.legal_case.defaultDocumentUrl,
      "readonly": _vm.readonlyForm
    }
  })], 1)]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.bTab
    }
  }, [_c('BriefOfEvidence', {
    ref: "brief_of_evidence",
    attrs: {
      "readonly": _vm.briefOfEvidenceReadonly
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.pTab
    }
  }, [_c('ProsecutionBrief', {
    ref: "prosecution_brief",
    attrs: {
      "readonly": _vm.prosecutionBriefReadonly
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.cpTab
    }
  }, [(_vm.legal_case.court_proceedings) ? _c('CourtProceedings') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.rTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": _vm.readonlyForm,
      "parentComponentName": "legal_case"
    }
  })], 1) : _vm._e()])])])], 1)])])])]), _vm._v(" "), (_vm.canUserAction) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.showSpinner && _vm.showExit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('exit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit()
      }
    }
  }, [_vm._v("Save and Exit")]), _vm._v(" "), (_vm.showSpinner && !_vm.showExit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('noexit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save and Continue")])])])])]) : _vm._e(), _vm._v(" "), (_vm.offenceInitialised) ? _c('div', [_c('Offence', {
    key: _vm.offenceBindId,
    ref: "offence",
    attrs: {
      "parent_update_function": _vm.loadLegalCase,
      "region_id": _vm.legal_case.region_id,
      "district_id": _vm.legal_case.district_id,
      "allocated_group_id": _vm.legal_case.allocated_group_id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sanctionOutcomeInitialised) ? _c('div', [_c('SanctionOutcome', {
    key: _vm.sanctionOutcomeBindId,
    ref: "sanction_outcome",
    attrs: {
      "parent_update_function": _vm.loadLegalCase
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.inspectionInitialised) ? _c('div', [_c('Inspection', {
    key: _vm.inspectionBindId,
    ref: "inspection",
    attrs: {
      "parent_update_function": _vm.loadLegalCase
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Magic', {
    ref: "magic"
  }), _vm._v(" "), (_vm.personOrArtifactInitialised) ? _c('div', [_c('PersonOrArtifactModal', {
    key: _vm.personOrArtifactBindId,
    ref: "person_or_artifact_modal",
    attrs: {
      "readonlyForm": _vm.readonlyForm,
      "rowNumberSelected": _vm.rowNumberSelected,
      "initialTabSelected": _vm.tabSelected,
      "entityEdit": _vm.entityEdit
    },
    on: {
      "modal-action": _vm.receivePersonOrArtifactEntity
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.runningSheetHistoryEntryBindId) ? _c('div', [_c('RunningSheetHistory', {
    key: _vm.runningSheetHistoryEntryBindId,
    ref: "running_sheet_history",
    attrs: {
      "runningSheetHistoryEntryInstance": _vm.runningSheetHistoryEntryInstance
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.legalCaseWorkflowBindId) ? _c('div', [_c('LegalCaseWorkflow', {
    key: _vm.legalCaseWorkflowBindId,
    ref: "legal_case_workflow",
    attrs: {
      "workflow_type": _vm.workflow_type
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.generateDocumentBindId) ? _c('div', [_c('GenerateDocument', {
    key: _vm.generateDocumentBindId,
    ref: "generate_document",
    attrs: {
      "document_type": _vm.documentTypeToGenerate
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7793212a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/legal_case/legal_case.vue
// module id = 1015
// module chunks = 0